import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ListItem } from '../../objects/listItem';
import { UserPermissions } from '../../objects/permissions';
import {SharedDataService} from "../../services/shared-data.service";
import {AppComponent} from "../../app.component";

@Component({
  selector: 'app-tile-listing-item',
  templateUrl: './tile-listing-item.component.html',
  styleUrls: ['./tile-listing-item.component.scss']
})
export class TileListingItemComponent implements OnInit {

  @Input() idx: number;
  @Input() listItem: ListItem;
  @Input() operationsAllowed: UserPermissions;
  @Input() activeItemCounter: number; //used in right click menu

  @Output() click = new EventEmitter<object>();
  @Output() clickShare = new EventEmitter<object>();
  @Output() clickEdit = new EventEmitter<object>();
  @Output() clickEditFolder = new EventEmitter<object>();
  @Output() clickAssignGroupUsers = new EventEmitter<object>();
  @Output() clickCourseShares = new EventEmitter<object>();
  @Output() clickStatic = new EventEmitter<object>();
  @Output() reorder = new EventEmitter<object>();
  @Output() export = new EventEmitter<object>();
  @Output() delete = new EventEmitter<object>();
  @Input() viewState: string;
  @Input() hideEditControl: boolean;

  isMouseOver = false;
  isTrainerLogin = false;
  isOwnerLogin = false;

  constructor(public application: AppComponent,
              sharedDataService: SharedDataService) { }

  ngOnInit(): void {
    this.isTrainerLogin = AppComponent.isTrainerLogin;
    this.isOwnerLogin = AppComponent.isOwnerLogin;
  }

  editFolder(event) {
    this['clickEditFolder'].emit();
    event.stopImmediatePropagation();
  }

  assignGroupUsers(event) {
    this['clickAssignGroupUsers'].emit();
    event.stopImmediatePropagation();
  }

  openCourseShares(event) {
    this['clickCourseShares'].emit();
    event.stopImmediatePropagation();
  }

  openStaticPage(event) {
    this['clickStatic'].emit();
    event.stopImmediatePropagation();
  }

  clickStop(event) {
    event.stopImmediatePropagation();
  }
  action(event, action) {
    this[action].emit();
  }

}
